// extracted by mini-css-extract-plugin
export default {"container":"TaskStatus_container__3aWCh","nbr":"TaskStatus_nbr__NiC8Z","status":"TaskStatus_status__Nm9Kh"};